import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default function PodcastEmbed({ url }) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="PrismicPodcastEmbed relative">
      <iframe
        className={classnames('w-100 h-100 overflow-hidden', { dn: isLoading })}
        onLoad={() => setIsLoading(false)}
        src={url}
        title={`podcast-embed-${url}`}
      />
      {isLoading && <div className="loading-spinner transform-center-all" />}
    </div>
  );
}

PodcastEmbed.propTypes = {
  url: PropTypes.string.isRequired
};
